import React from 'react';
import { Skeleton, Box, Stack, Grid, Divider, Chip } from '@mui/material';

const MyProfileSkeleton = () => {
  return (
    <Box className="mx-auto max-w-[1280px] px-4 md:px-8" sx={{ py: 3 }}>
      <Stack direction="row" justifyContent="space-between" spacing={3}>
        <Box>
          <Skeleton variant="text" width={240} height={36} />
          <Skeleton variant="text" width={180} height={28} />
          <Skeleton variant="text" width={220} height={24} />
        </Box>
        <Box>
          <Skeleton variant="text" width={180} height={24} />
          <Skeleton variant="text" width={160} height={24} />
          <Skeleton variant="text" width={160} height={24} />
        </Box>
      </Stack>

      <Divider sx={{ my: 3 }} />

      {/* Action Buttons */}
      <Stack direction="row" spacing={2} mb={4}>
        <Skeleton variant="rectangular" width={140} height={36} />
        <Skeleton variant="rectangular" width={180} height={36} />
      </Stack>

      {/* About Section */}
      <Skeleton variant="rectangular" height={80} width="100%" sx={{ mb: 4 }} />

      {/* Resume Sections */}
      {[...Array(4)].map((_, idx) => (
        <Box key={idx} sx={{ mb: 4 }}>
          <Skeleton variant="text" width={200} height={30} />
          <Stack spacing={2} mt={2}>
            {[...Array(2)].map((__, itemIdx) => (
              <Box key={itemIdx}>
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="40%" />
                <Skeleton variant="text" width="50%" />
                <Skeleton variant="rectangular" height={20} width="100%" />
              </Box>
            ))}
          </Stack>
        </Box>
      ))}

      {/* Pills Type Section for Skills */}
      <Box>
        <Skeleton variant="text" width={200} height={30} />
        <Box display="flex" flexWrap="wrap" gap={1} mt={2}>
          {[...Array(6)].map((_, i) => (
            <Chip key={i} label={<Skeleton width={60} />} variant="outlined" />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default MyProfileSkeleton;
